import { render, staticRenderFns } from "./SingleQuestion.vue?vue&type=template&id=0f16b0b0&scoped=true"
import script from "./SingleQuestion.vue?vue&type=script&lang=ts"
export * from "./SingleQuestion.vue?vue&type=script&lang=ts"
import style0 from "./SingleQuestion.vue?vue&type=style&index=0&id=0f16b0b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f16b0b0",
  null
  
)

export default component.exports